export function today() {
    return dayFrom(new Date());
}

export function dayFrom(date: Date|string|null) {
    if (!date) {
        return '';
    }

    if (date.constructor === String) {
        date = new Date(date);
    }

    return (date as Date).toISOString().split('T')[0];
}

export function todayWithOffset(offset: number) {
    const date = new Date();
    date.setDate(date.getDate() + offset);
    return date;
}